import * as React from 'react';
import '../css/section-message-secondary.sass';
import shouldFlipBG from '../utils/should-flip-bg';
import { SectionMessageType } from './SectionMessage';

interface SectionMessageSecondaryProps {
  message: SectionMessageType | '';
  theme?: 'day' | 'night';
}
interface SectionMessageSecondaryState {
  flipBg: string;
}

export default function SectionMessageSecondary(
  props: SectionMessageSecondaryProps
) {
  const { theme = 'day' } = props;
  const inputElParent = React.useRef(null);
  const [state, setState] = React.useState<SectionMessageSecondaryState>({
    flipBg: ''
  });

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputElParent, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
  }, []);

  if (!props.message) {
    return <></>;
  }
  return (
    <div
      ref={inputElParent}
      className={`sectionMessageSecondary ${state.flipBg}`}
    >
      <div className="section-message">
        <span className={`${props.message.type} icon`} />
        <div role="alert" aria-live="polite" className="secondary-message">
          {props.message.message}
        </div>
      </div>
    </div>
  );
}
